import React from 'react'
import { get } from 'lodash'

import { Modal } from '@/components/shared/Modal'
import { UserForm } from './UserForm'
import { Box, Button, Text, UseDisclosureProps } from '@chakra-ui/react'

import { User } from '../types'
import { CityCollection } from '@/features/types'

import { useSimulateToshiOsUnlink, useUpdateUser } from '../mutations'
import { transformUserIntoForm } from '../utils'
import { t } from '@/lib/helpers'

type Props = {
  disclosure: UseDisclosureProps
  initialData: User
  cities: CityCollection
}

export const EditUserModal = (props: Props) => {
  const { disclosure, initialData, cities } = props
  const { isOpen, onClose } = disclosure

  const { mutate: updateUser, isLoading } = useUpdateUser()
  const { mutate: simulateUnlink, isLoading: isUnlinking } =
    useSimulateToshiOsUnlink()

  return (
    <Modal isOpen={isOpen} onClose={onClose} withCloseButton>
      <Box sx={{ p: '32px', pb: '40px' }}>
        <Text textStyle="modalHeader" mb="20px">
          {t('views.admin.users.edit.title')}
        </Text>
        <UserForm
          isLoading={isLoading}
          defaultValues={transformUserIntoForm(initialData)}
          cities={cities}
          onSubmitForm={(data) => {
            updateUser(
              { form: data, id: get(initialData, 'id') },
              { onSuccess: onClose },
            )
          }}
        />
        {/* Never true in production: the serializer and the endpoint both refuse there. */}
        {get(initialData, 'can_simulate_toshi_os_unlink') === true && (
          <Button
            mt="24px"
            w="full"
            variant="outline"
            colorScheme="red"
            isLoading={isUnlinking}
            onClick={() => {
              if (!confirm(t('views.admin.users.simulate_toshi_os_unlink.confirm'))) return

              simulateUnlink(
                { id: get(initialData, 'id') },
                { onSuccess: onClose },
              )
            }}
          >
            {t('views.admin.users.simulate_toshi_os_unlink.button')}
          </Button>
        )}
      </Box>
    </Modal>
  )
}
